export default function faqUI () {
	$('.section-faq').each(function() {
		moveFAQEntries($(this));

		toggleFAQEntries($(this));
	})
}

const moveFAQEntries = ($section) => {
	const $faqItems = $section.find('.faq');

	$faqItems.each(function() {
		const $faqContent = $(this).find('.faq__content');
		const $sectionContent = $section.find('.section-faq__content');

		$faqContent.appendTo($sectionContent);
	});
}

const toggleFAQEntries = ($section) => {
	const $faqItems = $section.find('.faq');

	$faqItems.each(function() {
		const $faqItem = $(this);

		const $faqItemToggle = $faqItem.find('.faq__title a');

		$faqItemToggle.on('mouseenter click', function(event) {
			event.preventDefault();

			$(this).addClass('active');
			$(this).closest('.faq').siblings().find('.faq__title a').removeClass('active');

			const target = $(this).attr('href');
			$(target).addClass('active').siblings().removeClass('active');
		});
	});
}
